import React, { useState, FC } from 'react'
import { Trans, t } from '@lingui/macro'
import { Page } from '../../components/common/page/Page'
import PageHeader from '../../components/common/page/header/PageHeader'
import { ButtonPrimary } from 'front-end/src/components'

import Loader from '../../components/common/loader/Loader'
import { DashboardCard } from './DashboardCard'
import { NewDashboardModal } from './modals/NewDashboardModal'
import './DashboardsPage.less'
import CardGrid from '../../components/common/card-grid/CardGrid'
import IconPlus2 from '../../components/common/icon/IconPlus2'
import { useDashboardsQuery } from './DashboardsPage.codegen'
import EmptyDashboardSvg from 'public/assets/img/empty-dashboard.svg'

export const DashboardsPage: FC = () => {
  const [showCreateModal, setShowCreateModal] = useState(false)

  const { data, loading, refetch } = useDashboardsQuery()
  const dashboards = data?.admin?.dashboards

  return (
    <Page className="DashboardsPage">
      {loading && <Loader />}
      {Array.isArray(dashboards) && (
        <>
          <PageHeader
            className="PageHeader"
            title={t`Dashboards`}
            showBackButton={false}
            controls={
              <ButtonPrimary
                onClick={() => {
                  setShowCreateModal(true)
                }}
                leftIcon={<IconPlus2 />}
              >
                <Trans>New dashboard</Trans>
              </ButtonPrimary>
            }
          />
          {dashboards.length ? (
            <CardGrid
              cards={dashboards.map((d) => {
                return <DashboardCard key={d.id} dashboard={d} />
              })}
            />
          ) : (
            <div className="Dashboards__empty no-items">
              <img src={EmptyDashboardSvg} alt={t`Create a new dashboard`} />
              <h2>
                <Trans>No dashboards yet?</Trans>
              </h2>
              <p>
                <Trans>Create dashboard to view your important metrics.</Trans>
              </p>
            </div>
          )}
        </>
      )}

      {showCreateModal && (
        <NewDashboardModal
          refreshDashboards={refetch}
          onHide={() => setShowCreateModal(false)}
        />
      )}
    </Page>
  )
}
